import { ApiConfig } from "common/models";
import { CONTROLLER } from "common/config/endpoint.config";
import { buildGdxApiUrl } from "common/utils/api.util";

export const flowConfigConfig = {
  getAllFlowConfigurations: (): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/flowconfig/get-all`),
      "GET",
      "",
      undefined
    );
  },

  getFlowConfigurationsByDocumentType: (documentType: string): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(
        `${CONTROLLER.GDX_DATABASE}/document_type_information/get/${documentType}`
      ),
      "GET",
      documentType,
      undefined
    );
  },

  createFlowConfiguration: (flowConfig: any): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(`${CONTROLLER.GDX_DATABASE}/flowconfig/create`),
      "POST",
      undefined,
      flowConfig
    );
  },

  updateFlowConfiguration: (
    flowConfigId: number,
    flowConfig: any
  ): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(
        `${CONTROLLER.GDX_DATABASE}/flowconfig/update/${flowConfigId}?flow_id=${flowConfigId}`
      ),
      "PUT",
      flowConfigId.toString(),
      flowConfig
    );
  },

  deleteFlowConfiguration: (flowConfigId: number): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(
        `${CONTROLLER.GDX_DATABASE}/flowconfig/delete/${flowConfigId}`
      ),
      "DELETE",
      flowConfigId.toString(),
      undefined
    );
  },

  getFlowConfigurationById: (flowConfigId: number): ApiConfig => {
    return new ApiConfig(
      buildGdxApiUrl(
        `${CONTROLLER.GDX_DATABASE}/flowconfig/get/${flowConfigId}`
      ),
      "GET",
      flowConfigId.toString(),
      undefined
    );
  }
};
